module.exports = __webpack_public_path__ + "static/media/Cranidos_gaussian2.256d7c98.png";